import { FC } from 'react';
import { useHistory } from 'react-router-dom';
import { Add } from '@carbon/react/icons';
import { Button } from '@carbon/react';
import { PageHeader } from 'components/page-header';
import routes from '~/routes';
import DevelopmentPaceScenariosContent from './development-pace-scenarios-content';

const DevelopmentPaceScenariosPage: FC = () => {
  const history = useHistory();

  return (
    <>
      <PageHeader
        breadcrumbs={[]}
        title="Development Pace Configurations"
        actions={
          <Button
            renderIcon={Add}
            kind="primary"
            onClick={() => history.push(routes.newDevelopmentPaceScenarioPath)}
          >
            Add Development Pace Scenario
          </Button>
        }
      />
      <DevelopmentPaceScenariosContent />
    </>
  );
};

export { DevelopmentPaceScenariosPage };
